import React, { useEffect, useState } from 'react'
import MDButton from 'components/MDButton'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import { Edit } from '@mui/icons-material'
import { Button, Stack } from '@mui/material'
import { useAppServices, useUploadImage } from 'hook/services'
import { useUserInfo } from 'context/user'

const CreateModal = ({ appData, handleRefresh }) => {
  const uploadImage = useUploadImage()
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const [selectedImages, setSelectedImages] = useState([])
  const [error, setError] = useState(null)
  const AppService = useAppServices()

  const handlemodal = () => {
    setOpenAddProduct(true)
    setError(null) // Reset error when opening modal
  }

  const closeAddProduct = () => {
    setOpenAddProduct(false)
    setSelectedImages([]) // Clear selected images when closing
    setError(null)
  }

  useEffect(() => { }, [])

  function AddProduct({ open, onClose }) {
    const [processing, setProcessing] = useState(false)

    const handleImageChange = (e) => {
      try {
        const files = Array.from(e.target.files)
        if (files.length === 0) return

        const filePreviews = files.map((file) => ({
          file,
          preview: URL.createObjectURL(file),
        }))
        setSelectedImages(filePreviews)
        setError(null)
      } catch (err) {
        setError('Failed to process selected images')
        console.error(err)
      }
    }

    const handleSubmit = async (e) => {
      e.preventDefault()

      if (selectedImages.length === 0) {
        setError('Please select at least one image')
        return
      }

      setProcessing(true)
      setError(null)

      try {
        let images = [...appData.images || []]
        const uploadPromises = selectedImages.map(async (img) => {
          try {
            const image_response = await uploadImage({
              file: img.file,
              desiredPath: `app/logo/image`,
            })

            if (!image_response?.response?.data) {
              throw new Error('Failed to upload image')
            }

            return {
              image: image_response.response.data,
              type: 'sub-account', // Always set to 'sub-account'
            }
          } catch (err) {
            console.error('Error uploading image:', err)
            throw err
          }
        })

        const newImages = await Promise.all(uploadPromises)
        const updatedImages = [...images, ...newImages]

        const payload = {
          _id: appData._id,
          images: updatedImages,
        }

        const { response, error } = await AppService.app.update({
          payload: payload,
        })

        if (error) {
          throw new Error(error.message || 'Failed to update app')
        }

        if (response) {
          onClose()
          handleRefresh()
          setSelectedImages([])
        }
      } catch (err) {
        setError(err.message || 'An error occurred while saving images')
        console.error(err)
      } finally {
        setProcessing(false)
      }
    }

    const style = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 400,
      height: 'auto',
      overflow: 'auto',
      bgcolor: 'background.paper',
      border: '2px  #000',
      boxShadow: 24,
      p: 4,
    }

    return (
      <MDModal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
            <MDTypography variant="h5" mb={2}>
              App Images
            </MDTypography>

            {error && (
              <MDBox mb={2}>
                <MDTypography color="error" variant="caption">
                  {error}
                </MDTypography>
              </MDBox>
            )}

            <MDBox mt={2} mb={2} ml={1} display="flex" alignItems="center">
              <Stack direction="row" alignItems="center" spacing={2}
                sx={{ width: '100%' }}
              >
                <Button variant="contained" component="label"
                  sx={{
                    color: '#fff',
                    width: '100%', // Make button full width
                    py: 1.5, // Add some vertical padding
                  }}
                >
                  Upload Images +
                  <input
                    hidden
                    name="image"
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={handleImageChange}

                  />
                </Button>
              </Stack>
            </MDBox>

            {/* Preview Selected Images */}
            <MDBox mt={2}>
              {selectedImages.map((img, index) => (
                <img
                  key={index}
                  src={img.preview}
                  alt={`preview-${index}`}
                  style={{
                    width: '100px',
                    height: '100px',
                    margin: '5px',
                    objectFit: 'cover'
                  }}
                  onLoad={() => URL.revokeObjectURL(img.preview)} // Clean up memory
                />
              ))}
            </MDBox>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 4, mb: 1 }}
                onClick={closeAddProduct}
                disabled={processing}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 4, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing || selectedImages.length === 0}
              >
                Add
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    )
  }

  return (
    <>
      <MDButton color="white" size="small" variant="contained" onClick={handlemodal}>
        Upload Image
      </MDButton>
      <AddProduct open={openAddProduct} onClose={closeAddProduct} />
    </>
  )
}

export default CreateModal